module.exports = __webpack_public_path__ + "static/media/1.ed9ee7e4.jpg";